<template>
<!--  TODO CAREFUL - OLD PICKER NOT REPLACED YET - YOU SHOULD CONSIDER USING THE NEW ONE "<DatePicker>"-->
  <div class="date-range-picker">
    <div class="input-group">
      <input :id="id" type="text" class="form-control" :placeholder="placeholder">
      <div class="input-group-append position-relative" v-if="quickCompare">
        <button class="btn btn-primary" type="button" @click="showQuickCompare = !showQuickCompare">
          <Icon icon="fa-pro-solid:right-left" class="ify-sm" />
        </button>
        <div class="quick-range-select d-flex flex-column" v-if="showQuickCompare">
          <span class="badge" @click="setCompareDateRange(constants.LAST_INTERVAL)"
                :class="activeInterval === constants.LAST_INTERVAL ? 'bg-success' : 'bg-secondary'">
            vorheriger Zeitraum</span>
          <span class="badge mt-2" @click="setCompareDateRange(constants.LAST_YEAR_INTERVAL)"
                :class="activeInterval === constants.LAST_YEAR_INTERVAL ? 'bg-success' : 'bg-secondary'">
            vorheriges Jahr</span>
        </div>
        <button class="btn btn-primary" type="button" @click="clearDate">
          <Icon icon="fa-pro-solid:trash" class="ify-sm" />
        </button>
      </div>
      <div class="input-group-append position-relative" v-else>
        <button class="btn btn-primary" type="button" @click="showQuickDate = !showQuickDate">
          <Icon icon="fa-pro-solid:calendar-week" />
        </button>
        <div class="quick-range-select d-flex flex-column" v-if="showQuickDate">
          <span class="badge" @click="setDateRangeBadge(constants.DATE_RANGE.THIS_YEAR_END_OF_MONTH)" v-if="!isJanuary"
                :class="activeInterval === constants.DATE_RANGE.THIS_YEAR_END_OF_MONTH ? 'bg-success' : 'bg-secondary'">
            dieses Jahr (Monatsende)
          </span>
          <span class="badge mt-2" @click="setDateRangeBadge(constants.DATE_RANGE.THIS_YEAR)"
                :class="activeInterval === constants.DATE_RANGE.THIS_YEAR ? 'bg-success' : 'bg-secondary'">
            dieses Jahr
          </span>
          <span class="badge mt-2" @click="setDateRangeBadge(constants.DATE_RANGE.ONE_YEAR_END_OF_MONTH)"
                :class="activeInterval === constants.DATE_RANGE.ONE_YEAR_END_OF_MONTH ? 'bg-success' : 'bg-secondary'">
            1 Jahr (Monatsende)</span>
          <span class="badge mt-2" @click="setDateRangeBadge(constants.DATE_RANGE.ONE_YEAR)"
                :class="activeInterval === constants.DATE_RANGE.ONE_YEAR ? 'bg-success' : 'bg-secondary'">
            1 Jahr</span>
          <span class="badge mt-2" @click="setDateRangeBadge(constants.DATE_RANGE.LAST_YEAR)"
                :class="activeInterval === constants.DATE_RANGE.LAST_YEAR ? 'bg-success' : 'bg-secondary'">
            letztes Jahr
          </span>
          <span class="badge mt-2" @click="setDateRangeBadge(constants.DATE_RANGE.CURRENT_YEARS_EOM)"
                :class="activeInterval === constants.DATE_RANGE.CURRENT_YEARS_EOM ? 'bg-success' : 'bg-secondary'">
            letztes + dieses Jahr (Monatsende)
          </span>
          <span class="badge mt-2" @click="setDateRangeBadge(constants.DATE_RANGE.CURRENT_YEARS_EOQ)"
                :class="activeInterval === constants.DATE_RANGE.CURRENT_YEARS_EOQ ? 'bg-success' : 'bg-secondary'">
            letztes + dieses Jahr (Quartalsende)
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Litepicker from "litepicker";
import * as constants from '../stores/constants';
import dayjs from 'dayjs';

export default {
  props: {
    id: String,
    modelValue: Object,
    placeholder: String,
    quickCompare: {
      default: false,
      type: Boolean
    },
    compareRange: {
      default: null,
      type: Object
    }
  },
  data() {
    return {
      showQuickDate: false,
      showQuickCompare: false,
      compareInterval: null,
      activeInterval: null, // standard: dateRangeInterval | compare: compareInterval
      constants,
      picker: null,
    }
  },
  computed: {
    isJanuary() {
      return dayjs().month() === 0;
    }
  },
  watch: {
    modelValue: {
      handler() {
        if (!this.quickCompare) {
          this.syncActiveIntervalFromModel()
        }
      },
      deep: true,
    },
    compareRange: function() {
      // console.log("compareRange changed", this.quickCompare, JSON.stringify(this.activeInterval))
      if (this.quickCompare && this.activeInterval) {
        this.setCompareDateRange(this.activeInterval)
      }
    }
  },
  mounted() {
    this.picker = new Litepicker({
      element: document.getElementById(this.id),
      singleMode: false,
      lang: 'de-DE',
      format: 'DD.MM.YYYY',
      minDate: Date.parse('2021-01-01'),
      maxDate: Date.now(),
      startDate: this.modelValue.from,
      endDate: this.modelValue.to,
    });
    this.picker.on('selected', (date1, date2) => {
      this.activeInterval = null;
      this.$emit("update:modelValue", {from: date1, to: date2});
    });

    this.syncActiveIntervalFromModel()

    this.picker.ui.addEventListener('click', (e) => {
      e.stopPropagation()
    })
  },
  methods: {
    syncActiveIntervalFromModel() {
      const from = this.normalizeModelDate(this.modelValue?.from)
      const to = this.normalizeModelDate(this.modelValue?.to)

      if (!from || !to) {
        this.activeInterval = null
        return
      }

      const presets = [
        {
          key: constants.DATE_RANGE.THIS_YEAR,
          from: dayjs().startOf('year'),
          to: dayjs(),
        },
        {
          key: constants.DATE_RANGE.THIS_YEAR_END_OF_MONTH,
          from: dayjs().startOf('year'),
          to: dayjs().subtract(1, 'month').endOf('month'),
        },
        {
          key: constants.DATE_RANGE.ONE_YEAR,
          from: dayjs().subtract(1, 'year'),
          to: dayjs(),
        },
        {
          key: constants.DATE_RANGE.ONE_YEAR_END_OF_MONTH,
          from: dayjs().subtract(1, 'year').startOf('month'),
          to: dayjs().subtract(1, 'month').endOf('month'),
        },
        {
          key: constants.DATE_RANGE.LAST_YEAR,
          from: dayjs().subtract(1, 'year').startOf('year'),
          to: dayjs().subtract(1, 'year').endOf('year'),
        },
        {
          key: constants.DATE_RANGE.CURRENT_YEARS_EOM,
          from: dayjs().subtract(1, 'year').startOf('year'),
          to: dayjs().subtract(1, 'month').endOf('month'),
        },
        {
          key: constants.DATE_RANGE.CURRENT_YEARS_EOQ,
          from: dayjs().subtract(1, 'year').startOf('year'),
          to: dayjs().subtract(1, 'quarter').endOf('quarter'),
        },
      ]

      const matchedPreset = presets.find((preset) => {
        return from.isSame(preset.from, 'day') && to.isSame(preset.to, 'day')
      })

      this.activeInterval = matchedPreset?.key || null
    },
    normalizeModelDate(value) {
      if (!value) {
        return null
      }
      if (value.dateInstance) {
        return dayjs(value.dateInstance)
      }
      return dayjs(value)
    },
    setDateRangeBadge(interval) {
      let dFrom = dayjs()
      let dTo = dayjs()
      switch (interval) {
        case constants.DATE_RANGE.ONE_YEAR_END_OF_MONTH:
          dFrom = dayjs().subtract(1, 'year').startOf('month')
          dTo = dayjs().subtract(1, 'month').endOf('month')
          break
        case constants.DATE_RANGE.ONE_YEAR:
          dFrom = dayjs().subtract(1, 'year')
          dTo = dayjs()
          break
        case constants.DATE_RANGE.LAST_YEAR:
          dFrom = dayjs().subtract(1, 'year').startOf('year')
          dTo = dFrom.endOf('year')
          break
        case constants.DATE_RANGE.THIS_YEAR:
          dFrom = dayjs().startOf('year')
          dTo = dayjs()
          break
        case constants.DATE_RANGE.THIS_YEAR_END_OF_MONTH:
          dFrom = dayjs().startOf('year')
          dTo = dayjs().subtract(1, 'month').endOf('month')
          break
        case constants.DATE_RANGE.CURRENT_YEARS_EOQ:
          dFrom = dayjs().subtract(1, 'year').startOf('year')
          dTo = dayjs().subtract(1, 'quarter').endOf('quarter')
          break
        case constants.DATE_RANGE.CURRENT_YEARS_EOM:
          dFrom = dayjs().subtract(1, 'year').startOf('year')
          dTo = dayjs().subtract(1, 'month').endOf('month')
          break
      }
      this.picker.setDateRange(dFrom.toDate(), dTo.toDate())
      this.$emit("update:modelValue", {from: {dateInstance: dFrom.toDate()}, to: {dateInstance: dTo.toDate()}});

      this.activeInterval = interval;
      this.showQuickDate = false;
    },
    setCompareDateRange(interval) {
      let dFrom = dayjs(this.compareRange.from);
      let dTo = dayjs(this.compareRange.to);
      let compareDiff;
      switch(interval) {
        case constants.LAST_INTERVAL:
          compareDiff = dTo.diff(dFrom, 'days') + 1;
          dFrom = dFrom.subtract(compareDiff, 'days')
          dTo = dTo.subtract(compareDiff, 'days')
          break;
        case constants.LAST_YEAR_INTERVAL:
          dFrom = dFrom.subtract(1, 'year')
          dTo = dTo.subtract(1, 'year')
          break;
      }
      this.picker.setDateRange(dFrom, dTo)
      this.$emit("update:modelValue", {
        from: {dateInstance: dFrom.toDate()},
        to: {dateInstance: dTo.toDate()}
      });
      this.showQuickCompare = false;
      this.activeInterval = interval;
    },
    clearDate() {
      this.picker.clearSelection()
      this.activeInterval = null;
      this.$emit("update:modelValue", {from: null, to: null});
    }
  }
}
</script>
